import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-262" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-263" data-mp="cn7riumnqbzc">
        <div className="text-center mb-16" data-id="element-264" data-mp="cm508llfa7iw">
          <p className="text-azure font-bold tracking-widest uppercase text-sm mb-3" data-id="element-265" data-mp="7qhcmaml9mfi">
            What You Get: 7 Complete Volumes
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-navy" data-id="element-266" data-mp="3g355zfruq63h">
            📚 The Complete <span className="text-gold-solid" data-id="element-267" data-mp="3c1jm3agwgrjs">7-Volume</span> Coaching Library
          </h2>
          <p className="text-xl text-slate" data-id="element-268" data-mp="3px429y58uvni">
            <span className="text-gold-solid font-bold" data-id="element-269" data-mp="3l3svty4cggw4">150</span> complete coaching sessions
            · Event-specific progressions · Technical corrections · Coaching systems
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-270" data-mp="2sgf2e9zuu3gr">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} whileHover={{
          y: -4
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_10px_30px_rgba(217,155,18,0.2)]' : 'border-mist-dark shadow-sm'} p-8 pl-9 relative overflow-hidden flex flex-col h-full ${index === volumes.length - 1 && volumes.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-271" data-mp="29ga7nwv6nprv" data-mpi={index}>
              <span aria-hidden="true" className="absolute left-0 top-0 bottom-0 w-1.5" style={{
            backgroundColor: volume.accent
          }} data-id="element-272" data-mp="20diunsmnsly4" />
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-navy-dark font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-273" data-mp="3fvav1e656zmu">
                  MOST USED
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-274" data-mp="1brzudy3cvtdj">
                <span className="text-4xl" aria-hidden="true" data-id="element-275" data-mp="1brgd8jlj590k">
                  {volume.icon}
                </span>
                <div data-id="element-276" data-mp="1pp4vrks4k42g">
                  <div className="text-gold-dark font-bold text-sm uppercase tracking-wider" data-id="element-277" data-mp="1kso0m6micpfv">
                    {volume.number} · {volume.lessons}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-navy" data-id="element-278" data-mp="x0h5tbwfkqik">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-navy font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-279" data-mp="16upxxyhjuhg7">
                {volume.subtitle}
              </p>

              <div className="mb-6" data-id="element-280" data-mp="ebkcba8uy21e">
                <h4 className="text-sm font-bold text-azure uppercase tracking-wider mb-2" data-id="element-281" data-mp="eaj032g3v9i3">
                  What does this solve for your coaching?
                </h4>
                <p className="text-slate text-sm leading-relaxed" data-id="element-282" data-mp="2kzjlrveeaz2v">{volume.problem}</p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-283" data-mp="2ps4d8q9tx038">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-284" data-mp="2c1he4x05p86m">
                    <CheckCircle2 size={18} className="text-success shrink-0 mt-0.5" data-id="element-285" data-mp="2gy7u7kbyo3s1" />
                    <span className="text-slate text-sm" data-id="element-286" data-mp="34o253wcpzi9n">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-mist border border-mist-dark rounded-xl p-4 mt-auto" data-id="element-287" data-mp="38ovtsrxzl13l">
                <span className="text-navy font-bold block mb-1" data-id="element-288" data-mp="2upclnz56dpra">Result:</span>
                <p className="text-slate text-sm" data-id="element-289" data-mp="2zoz9t3mjkqev">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}